import React from "react";
import ArtistHero from "../components/ArtistHero";
import ArtistSwitcher from "../components/ArtistSwitcher";
import MusicSection from "../components/MusicSection";
import VideosSection from "../components/VideosSection";
import ExclusiveSection from "../components/ExclusiveSection";
import { useApp } from "../context/AppContext";
import { Sparkles } from "lucide-react";

export default function ArtistPage() {
  const { artist, current } = useApp();
  return (
    <main className={current ? "pb-28" : "pb-10"}>
      <ArtistHero />
      <ArtistSwitcher />
      <div className="px-5 mt-3">
        <p className="text-[13px] text-white/55 leading-relaxed">{artist.bio}</p>
        <div className="mt-3 inline-flex items-center gap-1.5 text-[11px] text-[#8b5cf6] bg-[#8b5cf6]/10 px-2.5 py-1 rounded-full">
          <Sparkles size={12} /> 100% artist-owned · direct to fans
        </div>
      </div>
      <MusicSection />
      <VideosSection />
      <ExclusiveSection />
      <footer className="px-5 pt-10 pb-6 text-center">
        <img src="/brand/s71-logo-sm.png" alt="S71" className="h-9 w-auto object-contain mx-auto opacity-40" />
        <p className="text-[11px] text-white/25 mt-2">Own your music. Go direct to consumer.</p>
      </footer>
    </main>
  );
}
